import { CopilotEngagementCategories } from 'consts/copilotControlConsts'

export const getSentimentEngagementScore = sentimentScore => {
  const numericScore = Number(sentimentScore)

  if (sentimentScore === null || sentimentScore === undefined || isNaN(numericScore)) {
    return null
  }

  if (numericScore >= 4) {
    return CopilotEngagementCategories.Positive
  } else if (numericScore === 3) {
    return CopilotEngagementCategories.Neutral
  } else {
    return CopilotEngagementCategories.Negative
  }
}

export const mapScoreToCategory = copilotChatSentimentScore => {
  const score = Number(copilotChatSentimentScore)

  if (score <= 2) {
    return CopilotEngagementCategories.Negative
  } else if (score === 3) {
    return CopilotEngagementCategories.Neutral
  }
  return CopilotEngagementCategories.Positive
}
